import bugsnag from '@bugsnag/js';

// Dont forget to server-prod.js's inlined version of this
const bugsnagClient = bugsnag({
    apiKey: process.env.BUGSNAG_API_KEY || '_',
    appType: process.env.BUGSNAG_APP_TYPE,
    appVersion: process.env.APP_VERSION || 'dev',
    notifyReleaseStages: ['production'],
    autoBreadcrumbs: process.env.NODE_ENV === 'production',
});

export type SendBugsnagErrorFn = (options: {
    error: Error;
    user?: {
        id: string;
    } | null;
    metaData?: object;
}) => void;
export const sendBugsnagError: SendBugsnagErrorFn = ({ error, metaData, user }) => {
    bugsnagClient.notify(error, {
        beforeSend: report => {
            if (user) {
                report.user = user;
            }
            if (metaData) {
                report.metaData = metaData;
            }
        },
    });
};

export default bugsnagClient;
